import {makeAutoObservable} from "mobx";

export interface IPaginationStore {
    clearPagination: () => void;
    size: number;
    setSize: (size: number) => void;
    offset: number;
    setOffset: (offset: number) => void;
    numberOfPages: number;
    setNumberOfPages: (numberOfPages: number) => void;
    numberOfElements: number;
    setNumberOfElements: (numberOfElements: number) => void;
}

export class PaginationStore implements IPaginationStore {
    _size: number;
    _numberOfPages: number;
    _numberOfElements: number;
    _offset: number;

    constructor() {
        makeAutoObservable(this);

        this._size = 20;
        this._numberOfPages = 0;
        this._numberOfElements = 0;
        this._offset = 0;
    }

    clearPagination() {
        this._offset = 0;
        this._size = 20;
        this._numberOfPages = 0;
        this._numberOfElements = 0;
    }

    get size() {
        return this._size;
    }

    setSize (size: number) {
        this._size = size;
    }

    get offset() {
        return this._offset;
    }

    setOffset (offset: number) {
        this._offset = offset;
    }

    get numberOfPages() {
        return this._numberOfPages;
    }

    setNumberOfPages (numberOfPages: number) {
        this._numberOfPages = numberOfPages;
    }

    get numberOfElements() {
        return this._numberOfElements;
    }

    setNumberOfElements (numberOfElements: number) {
        this._numberOfElements = numberOfElements;
    }
}
